export const LOCAL_BASE_URL = "https://api.digiauthentic.com/";
// export const LOCAL_BASE_URL = "http://localhost:5050/";

export const LOGIN = "api/auth/login";
export const FORGOT_PASSWORD = "api/auth/forgot-password";
